import styles from './css/Loading.css';

import React from 'react';
import { Spinner } from '@tcc/crate';

const Loading = () => {
  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <Spinner size={100} />
      </div>
    </div>
  );
};

export default Loading;
